import {
	KeyValue,
	KeyValuePipe
} from '@angular/common';
import {
	Pipe,
	PipeTransform
} from '@angular/core';

@Pipe( { name: 'keyValueNotSortingByDefault' } )
export class KeyValueNotSortingByDefaultPipe extends KeyValuePipe implements PipeTransform {

	/*
	 * Sets `() => 0` as comparison function for all overloads if no comparison
	 * function is provided, thus keeping the elements of the iterated object in
	 * their original order.
	 */
	private returnZero = () => 0;

	transform<K, V>( input: ReadonlyMap<K, V>, compareFn?: ( a: KeyValue<K, V>, b: KeyValue<K, V> ) => number ): Array<KeyValue<K, V>>;
	transform<K extends number, V>( input: Record<K, V>, compareFn?: ( a: KeyValue<string, V>, b: KeyValue<string, V> ) => number ): Array<KeyValue<string, V>>;
	transform<K extends string, V>(
		input: Record<K, V> | ReadonlyMap<K, V>, compareFn?: ( a: KeyValue<K, V>, b: KeyValue<K, V> ) => number
	): Array<KeyValue<K, V>>;
	transform( input: null | undefined, compareFn?: ( a: KeyValue<unknown, unknown>, b: KeyValue<unknown, unknown> ) => number ): null;
	transform<K, V>( input: ReadonlyMap<K, V> | null | undefined, compareFn?: ( a: KeyValue<K, V>, b: KeyValue<K, V> ) => number
	): Array<KeyValue<K, V>> | null;
	transform<K extends number, V>(
		input: Record<K, V> | null | undefined, compareFn?: ( a: KeyValue<string, V>, b: KeyValue<string, V> ) => number
	): Array<KeyValue<string, V>> | null;
	transform<K extends string, V>(
		input: Record<K, V> | ReadonlyMap<K, V> | null | undefined, compareFn?: ( a: KeyValue<K, V>, b: KeyValue<K, V> ) => number
	): Array<KeyValue<K, V>> | null {
		return super.transform<K, V>( input, compareFn ?? this.returnZero );
	}
}
